import { PATH_PREFIX_NON_FIRST_PAGE, QUERY_PARAM_NAME_PAGE } from '../../../constants/config';

interface IGetPaginationUrlParams {
  geoPath: string | null;
  finalQueryString: string | null;
  page: number;
}

export const getPaginationUrl = ({ page, geoPath, finalQueryString }: IGetPaginationUrlParams) => {
  const query = (finalQueryString && `${finalQueryString}&`) || '';
  const url = `${geoPath ? `/${geoPath}` : ''}/${PATH_PREFIX_NON_FIRST_PAGE}?${query}${QUERY_PARAM_NAME_PAGE}=${page}`;

  return url;
};
